import React from "react";
import { Link } from "react-router-dom";

import ModalInfo from "../../ModalInfo";

class Page2 extends React.Component {
  state = {
    visible: true,

    age: null,
    modalShow: true,
    modalTitle: "INSTRUCTIONS",
    modalContent: (
      <div>
        <p>Click on the different fields for more information.</p>
      </div>
    ),
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 2) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">
                    Steps to focus your thinking
                  </h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() =>
                      this.setState({
                        modalShow: true,
                        modalTitle: "INSTRUCTIONS",
                        modalContent: (
                          <div>
                            <p>
                              Click on the different fields for more
                              information.
                            </p>
                          </div>
                        ),
                      })
                    }
                  ></i>
                </div>
              </ul>
            </nav>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li
                      className="list-group-item form-card-selectable form-card-1 "
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Analyse what you really want",
                          modalContent: (
                            <div>
                              <p>
                                This step is all about you. Step back and
                                reflect on your interests, strengths and values.
                                Have a go at the{" "}
                                <Link to="/Module1" target="_blank">
                                  ‘I have no idea what I want to do’
                                </Link>{" "}
                                pathway and complete the self-awareness
                                activities.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">1</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Analyse what you really want</strong>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-2"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Make sure you are realistic",
                          modalContent: (
                            <div>
                              <p>
                                Fantasising about dream jobs is a universal
                                pastime – we all do it. But you may just find
                                the ‘right’ job is a much better bet. Focus on
                                your future with{" "}
                                <a
                                  target="_blank"
                                  href="http://blogs.bath.ac.uk/careers/"
                                >
                                  expert advice from our careers advisers blogs
                                </a>
                                .
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">2</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Make sure you are realistic</strong>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-1"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Focus on the gaps",
                          modalContent: (
                            <div>
                              <p>
                                Take a moment and think about the knowledge gaps
                                and how you can find out more information to get
                                to the next step. Do you need to find out more
                                about{" "}
                                <a
                                  target="_blank"
                                  href="https://targetjobs.co.uk/career-sectors"
                                >
                                  a particular sector
                                </a>{" "}
                                or{" "}
                                <a
                                  target="_blank"
                                  href="https://www.prospects.ac.uk/careers-advice/applying-for-jobs/what-skills-do-employers-want"
                                >
                                  the skills needed
                                </a>{" "}
                                ? Ensure you have assessed your{" "}
                                <a
                                  target="_blank"
                                  href="https://digitalcapability.jisc.ac.uk/what-is-digital-capability/"
                                >
                                  Digital Skills capabilities
                                </a>
                                .
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">3</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Focus on the gaps</strong>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-2"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Research and more research",
                          modalContent: (
                            <div>
                              <p>
                                Our Partners Prospects have a comprehensive{" "}
                                <a
                                  target="_blank"
                                  href="https://www.prospects.ac.uk/job-profiles/browse-a-to-z"
                                >
                                  list of job profiles
                                </a>
                                . However, don’t just limit yourself to desk
                                based research, talk to{" "}
                                <a
                                  target="_blank"
                                  href="https://www.bath.ac.uk/guides/using-bath-connection-as-a-careers-tool/"
                                >
                                  University of Bath alumni
                                </a>
                                ,{" "}
                                <a
                                  target="_blank"
                                  href="https://www.bath.ac.uk/services/myfuture/"
                                >
                                  employers on campus
                                </a>{" "}
                                and of course your lecturers.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">4</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Research and more research</strong>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-1"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Let it happen by chance",
                          modalContent: (
                            <div>
                              <p>
                                Be optimistic, more often than not career
                                opportunities appear by chance. Sometimes, the
                                opportunities that come our way may not match
                                the idea but can be a stepping stone to get to
                                the end goal. Go to the next page to learn about
                                planned happenstance.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">5</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Let it happen by chance</strong>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title={this.state.modalTitle}
              content={this.state.modalContent}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page2;
